import config from '../config';

function sendBingEvent(payload) {
  if (config.environment === 'production') {
    window.uetq = window.uetq || [];
    window.uetq.push(payload);
  }
}

export function reportSubscriptionPurchase(price, status, label) {
  sendBingEvent({ ec: label, ea: 'subscription', ev: price });

  // AdWords conversion event
  window.gtag('event', 'conversion', {
    send_to: 'AW-926426886/OHW6CMqnuWsQhs7guQM',
    value: price,
    currency: 'USD',
    transaction_id: '',
    status: status,
  });

  // GA conversion event
  window.gtag('event', 'conversion', {
    value: price,
    currency: 'USD',
    event_category: 'Subscription',
    event_label: label,
  });

  window.fbq('track', 'Purchase', {
    content_ids: ['1'],
    content_type: 'subscription',
    value: price,
    currency: 'USD',
  });
}

export function reportAffiliateSignup() {
  window.gtag('event', 'affiliate_signup');
}

export function reportTrainingPurchase(data) {
  window.gtag('event', 'conversion', {
    event_category: data.gaEventCategory || 'Training',
    event_label: data.gaEventLabel,
  });

  if (data.intercomEventName && data.intercomEventData) {
    sendIntercomEvent(data.intercomEventName, data.intercomEventData);
  }
}

export function sendIntercomEvent(eventName, data) {
  window.Intercom('trackEvent', eventName, data);
}



// WEBPACK FOOTER //
// ./src/common/events.js